import styled from 'styled-components';

export const LoadingRow = styled.li`
  display: flex;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing(1)};
`;
